// user
import users, {
    getUser,
    authUser,
    logoutUser,
    createNewUser,
    findUser,
    findUsers,
    getUserList,
    banUserById,
    unbanUserById,
    setUserToBlackList,
    setUserToWhiteList,
    getUserLimitationsList,
    toggleWhiteList,
    findUserById,
    updateUserSessionLimit,
} from './users';
// regions areas ports
import {
    getAreas,
    getArea,
    updateArea,
    updateAreaAlt,
    mergeAreaToArea,
    createArea,
    deleteArea,
    joinAreaToArea,
    transformAreaToPort,
    getAreaRelations,
    addAreaToArea,
} from './regions/areas';
import {
    getPorts,
    getAllPorts,
    getAllPortsWithAltNames,
    getAllPortsWithCountryNames,
    findPort,
    findPortAdmin,
    checkAndCreateRegion,
    updatePort,
    updatePortAlt,
    addNewPort,
    getPort,
    mergeAreaOrPortToPort,
    rejectPortModifications,
    approvePortModifications,
    approvePortModificationField,
    rejectPortModificationField,
    updatePortModificationField,
} from './regions/ports';
// contracts
import { getContracts, getTimeContracts } from './contracts';
// cargoes
import { getCargoTypes } from './cargoes/types';
import cargoAssigner, {
    getCargoAssigners,
    updateCargoAssigner,
    updateRealAdditionalInfo,
    getOneCargoByRealCargoId,
    getCargoGazetters,
    deleteCargoGazetter,
    getRealCargoNameWithGaz,
    getCargoAssignersPost,
} from './cargoes/assigners';
import { getTermEntities } from './cargoes/terms';
import { getCargoDuplicates, deleteCargoDuplicate } from './cargoes/duplicates';
import {
    getLoadingAndDischarging,
    updateLoadingAndDischarging,
    deleteLoadingAndDischarging,
} from './cargoes/ldRates';
import {
    getCargoNamesAutocomplete,
    getCargoRealNames,
    updateCargoRealName,
    checkForDeleteCargoName,
    convertUserCargoToAdmin,
    deleteCargoRealName,
    getTagsCategories,
    addTagsCategories,
    addTag,
    searchTags,
    saveTags,
    getCargoRealNamesPaginated,
} from './cargoes/realNames';
import {
    postRequestCargo,
    getCargoMonitor,
    changeUserCargoRequest,
    deleteCargoRequest,
} from './cargoes/requests';
import { getCargoByNameOrType, getCargoNamesMatches } from './cargoes/names';
// letters
import {
    getLetters,
    getLetter,
    updateLetter,
    sendRefNumber,
    sendLetterToArchive,
    saveAsSpam,
    fetchPredictorType,
} from './letters';
import { postAnnotations } from './annotations';

// gazetters
import {
    postGazetters,
    saveGazetters,
    saveGazettersNew,
    saveGazetterPartially,
    loadGazetteerIndex,
    saveGazetteerIndex,
    loadGazetteer,
    saveGazetteer,
    removeGazetteerDuplicates,
} from './gazetters';
// companies
import {
    findCompany,
    getCompanies,
    getRealCompanies,
    setNewParticipantsRoles,
    saveRealCompany,
    deleteRealCompany,
    findRealCompany,
} from './companies';
// countries
import { getCountries } from './counties';
// nationalities
import { getNationalities } from './nationalities';
// vessels
import {
    findVessel,
    getVessels,
    getVessel,
    deleteVessel,
    addVessel,
    deleteNameSuggestion,
    renameVessel,
    updateVessel,
    patchVesselFields,
    confirmVessel,
    updateVesselImage,
    checkImoNumberRegistered,
} from './vessels/vessels';
import {
    getVesselClaims,
    acceptUserClaimsToVessel,
    rejectUserClaimsToVessel,
} from './vessels/claims';
import {
    postRequestVessel,
    getVesselMonitor,
    changeUserVesselRequest,
    deleteVesselRequest,
} from './vessels/requests';
// yards
import { findYards, addYard, getYardById } from './yards';
// register classes
import { findClasses, addClass, getClassById } from './registerClass';
// pi clubs
import { findPIClubs, addPIClub, getPIClubById } from './piClubs';
// statistics
import { getStatisticsUsers } from './statistics/users';
import { getStatisticsEmails } from './statistics/emails';
import { getStatisticsMonitor } from './statistics/monitor';
import { getStatisticsSt } from './statistics/st';
import { getStatisticsCargoRequests } from './statistics/cargoRequests';
import { getStatisticsVesselPositions } from './statistics/vesselPositions';
import { getCompositionStats } from './statistics/composition';
// files
import { uploadFile } from './files';

// serviceProvider
import {
    rejectServiceProvider,
    approveServiceProvider,
    getServiceProvidersHistory,
    updateServiceProviders,
    approveNewServiceProvider,
    rejectNewServiceProvider,
    approveRemoveServiceProvider,
    rejectRemoveServiceProvider,
} from './regions/serviceProvider.js';

// preferences
import {
    updatePreference,
    deletePreference,
    getPreference,
    getPreferences,
    updatePreferenceMeta,
} from './preferences';
import { createFilterAnnotationsPreference } from './preferences/filterAnnotations';
import {
    getMailRecognizeSpamList,
    createMailRecognizeSpamList,
    updateMailRecognizeSpamList,
} from './preferences/mailRecognizeSpamList';

// sender emails
import { getSendEmailList, getSendEmail } from './sender';

import * as packingList from './packingList';

// domains
import { connectNewDomainToUser, deleteDomain, getListDomain } from './domains';

// sender emails
import { getSubscribers } from './users/subscribers';

// notifications
import {
    getBackendNotifications,
    getBackendNotification,
    deleteBackendNotification,
    updateBackendNotification,
    createBackendNotification,
} from './backendNotifications';

// time charter

import timeCharters from './timeCharters';
import fuel from './fuel';
import disbursement from './disbursement';
import {
    getIntegrators,
    getIntegratorCompanies,
    getCompanyUser,
} from './integrators/integrators';

// cargo req ldrates
import { getReqLDRates, deleteReqLDRate, editReqLDRate, addReqLDRate } from './reqLDRates';

// mailers
import { addMailerGoogle, getInternalMailers, removeInternalMailer } from './analytics/mailers';

// new trainings
import { sendTrainings, deleteTraining } from './trainings';

// pda
import { pdaGetAll, pdaDelete, pdaUpdate, pdaAdd } from './prices';

// design
import { findVesselDesign } from './design';

// tc
import { postRequestTc, getRequestsTc, deleteTcRequest } from './tc/requests';
// sales
import { postVesselSale, getVesselSales, deleteVesselSale } from './vessels/sales';

// vessel composition
import { 
    getEmailsForVesselComposition, approveVesselSize, rejectVesselSize,
    getVesselsCompositions,
} from './vessels/composition';

// analytics
import { 
    getAnalyticsLinksList, createAnalyticsLinks, updateAnalyticsLinksList, deleteAnalyticLink, findAnalyticsTags,
    sendToDev,
} from './analytics/linksList';

// flag compliance
import { getFlagCompliance, updateFlagCompliance } from './flagCompliance';

// sanctions
import { getVesselSanctions, updateVesselCompliance } from './sanctions';

// tc indexes
import { 
    getPredefinedIndexes, getTcHireIdeas, getVesselDwtTypes, 
    approveHireIdea, rejectHireIdea, updateHireIdea, getVias, getPortMainRegion, exportTcIndexes, 
} from './tc/indexes';

// hs codes
import { hsCodeFind } from './hsCodes';

// issues
import { getIssues, getIssue, updateIssueStatus, addIssueComment, deleteIssueComment, updateIssueComment } from './issues';

// orders
import { saveRequestsDataCreated, saveRequestsDataDeleted } from './orders';

// hires
import { getHiresList, postRequestHire, updateHireIdeas, exportHireIdeas } from './hires/requests';
// dev-utils
import { idsConvert, idsEntities } from './devUtils';

// congestion
import {
    getCongestionMeta, getCongestionPort, getCongestionRuns, getCongestionRun,
    estimateCongestionScan, startCongestionScan, startCongestionCalculate, getCongestionHexCells,
    confirmCongestionHexCells, rejectCongestionHexCells, deleteCongestionHexCells, getCongestionZones,
    createCongestionZone, renameCongestionZone, addCongestionCellsToZone, removeCongestionCellsFromZone,
    mergeCongestionZones, getCongestionStats, getCongestionHistogram, getCongestionVesselTrack,
} from './congestion';

const api = {
    users,
    getUser,
    authUser,
    logoutUser,
    createNewUser,
    findUser,
    findUsers,
    findUserById,
    updateUserSessionLimit,
    getUserList,
    banUserById,
    unbanUserById,

    getAreas,
    getArea,
    updateArea,
    deleteArea,
    updateAreaAlt,
    createArea,
    transformAreaToPort,
    joinAreaToArea,
    getAreaRelations,
    addAreaToArea,

    checkAndCreateRegion,
    findPort,
    findPortAdmin,

    getPorts,
    getAllPorts,
    getAllPortsWithCountryNames,
    getAllPortsWithAltNames,

    getServiceProvidersHistory,

    updatePort,
    updatePortAlt,
    addNewPort,
    getPort,
    mergeAreaOrPortToPort,
    mergeAreaToArea,
    getCargoTypes,

    approvePortModificationField,
    rejectPortModificationField,
    updatePortModificationField,

    getContracts,
    getTimeContracts,

    cargoAssigner,
    getCargoAssigners,
    getCargoAssignersPost,
    getCargoGazetters,
    deleteCargoGazetter,
    updateCargoAssigner,
    getOneCargoByRealCargoId,
    updateRealAdditionalInfo,
    getRealCargoNameWithGaz,

    getTermEntities,

    getCargoDuplicates,
    deleteCargoDuplicate,

    getLoadingAndDischarging,
    updateLoadingAndDischarging,
    deleteLoadingAndDischarging,

    getLetters,
    getLetter,
    updateLetter,
    sendRefNumber,
    sendLetterToArchive,
    saveAsSpam,
    fetchPredictorType,

    postAnnotations,
    postRequestCargo,
    getCargoMonitor,
    changeUserCargoRequest,
    deleteCargoRequest,

    getCargoByNameOrType,

    getCargoNamesAutocomplete,
    getCargoRealNames,
    updateCargoRealName,
    checkForDeleteCargoName,
    convertUserCargoToAdmin,
    deleteCargoRealName,
    getTagsCategories,
    addTagsCategories,
    addTag,
    searchTags,
    saveTags,
    getCargoRealNamesPaginated,
    getCargoNamesMatches,
    postGazetters,
    saveGazetters,
    saveGazettersNew,
    saveGazetterPartially,
    loadGazetteerIndex,
    saveGazetteerIndex,
    loadGazetteer,
    saveGazetteer,
    removeGazetteerDuplicates,

    findCompany,
    getCompanies,
    getRealCompanies,
    findRealCompany,
    saveRealCompany,
    deleteRealCompany,

    getCountries,

    getNationalities,

    findYards,
    addYard,
    getYardById,

    findClasses,
    addClass,
    getClassById,

    findPIClubs,
    addPIClub,
    getPIClubById,
    deleteNameSuggestion,
    renameVessel,
    findVessel,
    getVessels,
    confirmVessel,
    getVessel,
    deleteVessel,
    addVessel,
    updateVessel,
    patchVesselFields,
    updateVesselImage,
    checkImoNumberRegistered,

    postRequestVessel,
    getVesselMonitor,
    changeUserVesselRequest,
    deleteVesselRequest,

    getVesselClaims,
    acceptUserClaimsToVessel,
    rejectUserClaimsToVessel,

    getStatisticsUsers,
    getStatisticsEmails,
    getStatisticsMonitor,
    getStatisticsCargoRequests,
    getStatisticsVesselPositions,
    getCompositionStats,

    uploadFile,

    setUserToBlackList,
    setUserToWhiteList,
    getUserLimitationsList,
    toggleWhiteList,

    rejectPortModifications,
    approvePortModifications,

    rejectServiceProvider,
    approveServiceProvider,
    updateServiceProviders,
    approveNewServiceProvider,
    rejectNewServiceProvider,
    approveRemoveServiceProvider,
    rejectRemoveServiceProvider,
    
    createFilterAnnotationsPreference,

    updatePreference,
    deletePreference,
    getPreference,
    getPreferences,
    updatePreferenceMeta,

    getMailRecognizeSpamList,
    createMailRecognizeSpamList,
    updateMailRecognizeSpamList,

    getSendEmailList,
    getSendEmail,
    getStatisticsSt,

    connectNewDomainToUser,
    deleteDomain,
    getListDomain,

    getSubscribers,

    getBackendNotifications,
    getBackendNotification,
    deleteBackendNotification,
    updateBackendNotification,
    createBackendNotification,
    ...packingList,
    timeCharters,
    fuel,
    disbursement,
    setNewParticipantsRoles,
    getReqLDRates,
    deleteReqLDRate,
    editReqLDRate,
    addReqLDRate,
    
    sendTrainings,
    deleteTraining,

    pdaGetAll,
    pdaDelete,
    pdaUpdate,
    pdaAdd,
    getIntegrators,
    getIntegratorCompanies,
    getCompanyUser,
    findVesselDesign,
    postRequestTc,
    getRequestsTc,
    deleteTcRequest,
    postVesselSale,
    getVesselSales,
    deleteVesselSale,

    getAnalyticsLinksList,
    createAnalyticsLinks,
    updateAnalyticsLinksList,
    deleteAnalyticLink,
    findAnalyticsTags,
    addMailerGoogle,
    getInternalMailers,
    removeInternalMailer,

    getFlagCompliance,
    updateFlagCompliance,

    getVesselSanctions,
    updateVesselCompliance,
    
    getEmailsForVesselComposition,
    approveVesselSize, 
    rejectVesselSize,
    getVesselsCompositions,
    getPredefinedIndexes,
    getTcHireIdeas,
    exportTcIndexes,
    getVesselDwtTypes,
    approveHireIdea,
    rejectHireIdea,
    updateHireIdea,
    getVias,
    getPortMainRegion,
    
    sendToDev,

    hsCodeFind,

    getIssues,
    getIssue,
    updateIssueStatus,
    addIssueComment, 
    deleteIssueComment, 
    updateIssueComment,

    saveRequestsDataCreated,
    saveRequestsDataDeleted,

    getHiresList, 
    postRequestHire,
    updateHireIdeas,
    exportHireIdeas,
    idsConvert,
    idsEntities,
    // congestion
    getCongestionMeta,
    getCongestionPort,
    getCongestionRuns,
    getCongestionRun,
    estimateCongestionScan,
    startCongestionScan,
    startCongestionCalculate,
    getCongestionHexCells,
    confirmCongestionHexCells,
    rejectCongestionHexCells,
    deleteCongestionHexCells,
    getCongestionZones,
    createCongestionZone,
    renameCongestionZone,
    addCongestionCellsToZone,
    removeCongestionCellsFromZone,
    mergeCongestionZones,
    getCongestionStats,
    getCongestionHistogram,
    getCongestionVesselTrack,
};

export default api;



// WEBPACK FOOTER //
// ./app/services/index.js